import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../components/atoms/icon";
import { Author, ClosingQuote, Comma, Description, RatingWrapper, CardConatiner, Rating, Wrapper, } from "./index.styled";
const StarRating = ({ count }) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
        const ratingCount = Number(count);
        stars.push(React.createElement("label", { className: ratingCount > i ? "active" : "inactive" }, "\u2605"));
    }
    return React.createElement(Rating, null, stars);
};
export const UserReviewCards = ({ userReviews, width }) => {
    return (React.createElement(React.Fragment, null, userReviews.map((item) => (React.createElement(CardConatiner, { style: { width } },
        React.createElement(Wrapper, null,
            React.createElement(Comma, null,
                React.createElement(Icon, { type: Icons.ClosingInvertedCommas, className: "icon", color: "#000000" })),
            React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Description, null, description)), item.description))),
        React.createElement(Wrapper, null,
            React.createElement(RatingWrapper, null,
                React.createElement(RenderMaybe, null, M.map((author) => (React.createElement(Author, null, author)), item.author)),
                React.createElement(StarRating, { count: item.rating })),
            React.createElement(ClosingQuote, null,
                React.createElement(Icon, { type: Icons.OpenInvertedCommas, className: "icon", color: "#000000" }))))))));
};

